import { render, staticRenderFns } from "./ImportMailsPage.vue?vue&type=template&id=53b5ebc0&scoped=true&"
import script from "./ImportMailsPage.vue?vue&type=script&lang=ts&"
export * from "./ImportMailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ImportMailsPage.vue?vue&type=style&index=0&id=53b5ebc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5ebc0",
  null
  
)

export default component.exports